// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;The Lord looses those that are bound;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the Lord opens the eyes of the blind;<br> </p> </div></div>";
// Exports
module.exports = code;